module.exports = __webpack_public_path__ + "static/media/retusch_IMG_20250225_091639.ee415d40.webp";